import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import type { SettlementSummaryFilterValues } from '@/features/settlement/settlement-summary/settlement-summary.types';
import type { SettlementReportDetailFilterValues } from '@/features/settlement/settlement-report-detail/settlement-report-detail.types';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

export const settlementRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: 'settlement',
  component: lazyRouteComponent(() => import('@/pages/settlement/settlement-page')),
  beforeLoad: ({ location }) => {
    if (location.pathname === '/settlement') {
      throw redirect({
        to: '/settlement/summary',
        search: undefined as unknown as SettlementSummaryFilterValues,
      });
    }
  },
});
export const settlementSummaryRoute = createRoute({
  getParentRoute: () => settlementRoute,
  path: 'summary',
  component: lazyRouteComponent(() => import('@/pages/settlement/settlement-summary-page')),
  validateSearch: (search: Record<string, unknown>): Partial<SettlementSummaryFilterValues> => {
    return {
      ...search,
    };
  },
});
export const settlementReportRoute = createRoute({
  getParentRoute: () => settlementRoute,
  path: 'report',
  component: lazyRouteComponent(() => import('@/pages/settlement/settlement-report-page')),
  validateSearch: (search: Record<string, unknown>): Partial<SettlementSummaryFilterValues> => {
    return {
      ...search,
    };
  },
});

export const settlementReportDetailRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: 'settlement/report/detail',
  component: lazyRouteComponent(() => import('@/pages/settlement/settlement-detail-page')),
  validateSearch: (
    search: Record<string, unknown>,
  ): Partial<SettlementReportDetailFilterValues> => {
    return {
      ...search,
    };
  },
});
